export const PURCHASE_STATUS_ENUM = {
  // 0: {
  //   label: "全部信息",
  //   code: 0,
  // },
  0: {
    label: "待报价",
    code: 0,
    color: "#f7b753",
  },
  1: {
    label: "比价中",
    code: 1,
    color: "#fd2220",
  },
  2: {
    label: "已完成",
    code: 2,
    color: "#999",
  },
  3: {
    label: "报价已截止",
    code: 3,
    color: "#999",
  },
  4: {
    label: "审核中",
    code: 4,
    color: "#999",
  },
  5: {
    label: "审核未通过",
    code: 5,
    color: "#999",
  },
};

export const PURCHASE_CARD_STATUS_ENUM = {
  0: "报价中",
  1: "结束",
  2: "关闭",
  3: "拒绝",
  4: "成功",
};

export const PURCHASE_TYPE_ENUM = {
  0: "招标",
  1: "急购",
};

// let publishStatusEnum= {
//   0: "待报价",
//   1: "比价中",
//   2: "已完成",
//   3: "结束",
//   4: "审核中",
//   5: "审核失败",
// },
